import { useHandleExporterImporterSwap as useHandleExporterImporterSwapBase } from "@atlas-int/controls";
import type { DecodedExploreParams } from "../../../visualization/paramSchemas";
import { useExploreParams } from "../../../visualization/paramSchemas";
import { googleAnalyticsCustomEvent } from "../../../sharedUtilities/analytics";
import { worldGroupDatum } from "@atlas-int/data";

export const useHandleExporterImporterSwap = () => {
  const [{ importer, exporter, tradeDirection, view }, setQuery] =
    useExploreParams();

  return useHandleExporterImporterSwapBase({
    importer,
    exporter,
    tradeDirection,
    view,
    worldGroupId: worldGroupDatum.groupId,
    onSwap: (result) => setQuery(result as Partial<DecodedExploreParams>),
    onAnalytics: () =>
      googleAnalyticsCustomEvent("btn", "click", "swaptrade", "explore"),
  });
};
